<template>
  <div class="productos-otro">

    <div class="crea-tu-formulario">Detalles</div>
    <div v-for="(item, i) in fields" :key="i">
      <div class="frame-container" v-if="item.type === 'text'">
        <div class="frame-wrapper">
            <div class="frame-div">
                <div class="pregunta-de-seleccin-selecci-wrapper">
                    <div class="cantidad">
                        <div class="pregunta-de-seleccin-selecci">
                            {{ (i + 1) }}. {{ item.label }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="frame-parent1">
          <div class="wrapper">
            <input type="text" class="input-texto-quantity" v-model="internalValue[item.label]" >
          </div>
        </div>
      </div>
      <div class="frame-container" v-if="item.type === 'number'">
        <div class="frame-wrapper">
            <div class="frame-div">
                <div class="pregunta-de-seleccin-selecci-wrapper">
                    <div class="cantidad">
                        <div class="pregunta-de-seleccin-selecci">
                            {{ (i + 1) }}. {{ item.label }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="frame-parent1">
          <div class="wrapper">
            <input type="number" class="input-number" v-model.number="internalValue[item.label]" >
          </div>
        </div>
      </div>
      <div class="frame-container" v-if="item.type === 'select'">
          <div class="frame-wrapper">
              <div class="frame-div">
                  <div class="pregunta-de-seleccin-selecci-wrapper">
                      <div class="cantidad">
                          <div class="pregunta-de-seleccin-selecci">
                              {{ (i + 1) }}. {{ item.label }}
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="frame-parent1">
            <div class="ellipse-parent" v-for="(element, i) in item.items" :key="i">
                <input type="radio" class="frame-child" :value="element" :name="item.label" v-model="internalValue[item.label]">
                <label for="option1" class="opcin-1-wrapper">
                    <div class="aadir-opcin">{{ element }}</div>
                </label>
            </div>
          </div>

      </div>
      <div class="frame-container" v-if="item.type === 'checkbox'">
          <div class="frame-wrapper">
              <div class="frame-div">
                  <div class="pregunta-de-seleccin-selecci-wrapper">
                      <div class="cantidad">
                          <ol class="pregunta-de-seleccin-selecci">
                              {{ (i + 1) }}. {{ item.label }}
                          </ol>
                      </div>
                  </div>
              </div>
          </div>
          <div class="frame-parent1">
            <div class="ellipse-parent" v-for="(element, i) in item.items" :key="i">
              <input type="checkbox" class="rectangle-div" :value="element" :name="item.label" v-model="internalValue[item.label]">
              <label for="option1" class="opcin-1-wrapper">
                  <div class="aadir-opcin">{{ element }}</div>
              </label>
            </div>
          </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: 'CustomizationAddProduct',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    fields: {
      type: Array,
      default: () => ([])
    }
    // currency: {
    //   type: String,
    //   default: 'CRC'
    // },
    // exchangeRate: {
    //   type: Number,
    //   default: 1
    // },
    // priceList: {
    //   type: String,
    //   default: 'general'
    // }
    // Aquí es donde se declararían las propiedades de tu componente
  },
  data () {
    return {
      lazyValue: this.value
    }
  },
  computed: {
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        console.log('internalValue', { ...val })
        this.$emit('input', this.lazyValue)
      }
    }
  },
  watch: {
    value (val) {
      this.lazyValue = val
    }
    // lazyValue: {
    //   handler (val) {
    //     console.log('lazyValue', val)
    //     if (!val) return
    //     this.$emit('input', val)
    //   },
    //   deep: true
    // }
  },
  methods: {
    setValue (field, value) {
      console.log(field, value)
      this.lazyValue[field] = value
      this.$emit('input', this.lazyValue)
    }
  },
  beforeCreate () {
    // Acciones antes de crear el componente
  },
  created () {
    // Acciones al crear el componente
  },
  beforeMount () {
    // Acciones antes de montar el componente
  },
  mounted () {
  },
  beforeUpdate () {
    // Acciones antes de actualizar el componente
  },
  updated () {
    // Acciones al actualizar el componente
  },
  beforeDestroy () {
  },
  destroyed () {
    // Acciones al destruir el componente
  }
}
</script>
<style scoped>
.datos-del-cliente {
    position: relative;
    line-height: 24px;
    font-weight: 500;
}
.titulo-seccion {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px 0px;
    font-size: 24px;
    color: #480ca8;
    font-family: Rubik;
}
.vector-icon {
    width: 16.1px;
    position: relative;
    height: 16.1px;
}
.magebar-code-scan {
    width: 20.9px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 2.1px;
    box-sizing: border-box;
}
.input-texto-quantity {
    width: 260.19px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: none;
    outline: none;
    background: transparent;
    font-size: 14px; /* Ajusta el tamaño de fuente si es necesario */
}
.input-number {
    width: 260.19px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: none;
    outline: none;
    background: transparent;
    text-align: right;
    font-size: 14px; /* Ajusta el tamaño de fuente si es necesario */
}
.input-texto {
    width: 214px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: none;
    outline: none;
    background: transparent;
    text-align: center;
    font-size: 14px; /* Ajusta el tamaño de fuente si es necesario */
}
.caja-de-texto {
    width: 230px;
    border-radius: 16px;
    border: 1px solid #4361ee;
    box-sizing: border-box;
    height: 21px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
}
.group-icon {
    width: 18.8px;
    position: relative;
    height: 18.8px;
}
.magebar-code-scan-parent {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    text-align: center;
}
.desplegable {
    width: 62.3px;
    position: relative;
    display: flex;
    align-items: center;
    flex-shrink: 0;
}
.icon-chevron {
    width: 10px;
    position: relative;
    height: 10px;
    overflow: hidden;
    flex-shrink: 0;
    object-fit: contain;
}
.desplegables {
    border-radius: 16px;
    border: 1px solid #4361ee;
    box-sizing: border-box;
    height: 21px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    gap: 6px;
}
.cantidad {
    position: relative;
    font-weight: 500;
}
.div {
    position: relative;
}
.wrapper {
    border-radius: 8px;
    border: 1px solid #4361ee;
    box-sizing: border-box;
    height: 22.7px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 4px 8px;
    font-size: 11px;
    color: #979797;
}
.cantidad-parent {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    font-size: 12px;
    color: #535763;
}
.frame-parent {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: flex-start;
    gap: 20px;
    font-size: 11px;
    color: #979797;
}
.container {
    border-bottom: 1px solid #4361ee;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 2px 8px;
    font-size: 11px;
    color: #979797;
}
.ancho-parent {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
}
.frame-group {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    padding: 8px 20px;
    gap: 17px;
    font-size: 12px;
}
.productos-child {
    align-self: stretch;
    position: relative;
    max-width: 100%;
    overflow: hidden;
    max-height: 100%;
}
.crea-tu-formulario {
    align-self: stretch;
    position: relative;
    font-size: 20px;
    letter-spacing: 0.16px;
    line-height: 25.11px;
    font-weight: 500;
    font-family: Rubik;
}
.pregunta-de-seleccin-selecci {
    margin: 0;
    font-family: inherit;
    font-size: inherit;
}
.pregunta-de-seleccin-selecci-wrapper {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
}
.frame-div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}
.frame-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
}
.custom-checkbox {
    width: 18.9px;
    height: 18.9px;
    position: relative;
    border-radius: 50%;
    border: 2.1px solid #4361ee;
    box-sizing: border-box;
    appearance: none; /* Oculta el estilo predeterminado del checkbox */
    cursor: pointer;
}
.custom-checkbox:checked {
    background-color: #4361ee; /* Color de fondo cuando está seleccionado */
}
.custom-radio {
    width: 18.9px;
    height: 18.9px;
    position: relative;
    display: inline-block;
    border-radius: 50%;
    border: 2.1px solid #4361ee;
    box-sizing: border-box;
    cursor: pointer;
}

/* Ocultar el input radio original */
.custom-radio input[type="radio"] {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
}

/* Estilo para cuando el radio button está seleccionado */
.custom-radio input[type="radio"]:checked + .custom-radio {
    background-color: #4361ee;
}
.frame-child {
    width: 18.9px;
    height: 18.9px;
    position: relative;
    border-radius: 50%;
    border: 2.1px solid #4361ee;
    box-sizing: border-box;
    appearance: none; /* Oculta el radio button original */
    cursor: pointer;
}

.frame-child:checked {
    background-color: #4361ee; /* Color de fondo cuando está seleccionado */
}

.opcin-1-wrapper {
    width: 243.3px;
    border-radius: 8.37px;
    background-color: #ebf1ff;
    height: 23.7px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 6.3px 16.7px;
    box-sizing: border-box;
}
.ellipse-parent {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
}
.frame-parent1 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 6.3px;
    font-size: 11px;
    color: #000;
}
.frame-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 16.7px;
}
.rectangle-div {
    width: 18.8px;
    height: 18.8px;
    position: relative;
    border: 2.1px solid #4361ee;
    box-sizing: border-box;
    appearance: none; /* Remueve el estilo por defecto del checkbox */
    -webkit-appearance: none; /* Para compatibilidad con navegadores basados en WebKit */
    background-color: #fff; /* Fondo blanco para que parezca el div original */
    cursor: pointer; /* Añade un cursor de mano para simular el checkbox */
}

.rectangle-div:checked {
    background-color: #4361ee; /* Color de fondo al estar seleccionado */
}
.aadir-opcin {
    flex: 1;
    position: relative;
}
.detalles-aparecen-en-factura-wrapper {
    align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
}
.agregue-los-detalles {
    margin: 0;
}
.agregue-los-detalles-correspon-wrapper {
      align-self: stretch;
      border-radius: 8px;
      border: 1px solid #4361ee;
      padding: 6px 8px;
      display: block;
      resize: none; /* Evita que el usuario cambie el tamaño */
      font-family: inherit; /* Mantener la misma fuente */
      font-size: inherit; /* Mantener el tamaño de fuente */
}
.frame-wrapper3 {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    font-size: 12px;
    color: #000;
}
.frame-parent4 {
    align-self: stretch;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 6px;
}
.div3 {
    width: 76.2px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    border: none;
    background-color: transparent;
    text-align: center;
    appearance: none; /* Elimina estilos por defecto de input */
    -moz-appearance: textfield; /* Elimina flechas en Firefox */
}

.div3::-webkit-inner-spin-button,
.div3::-webkit-outer-spin-button {
    -webkit-appearance: none; /* Elimina flechas en WebKit */
    margin: 0;
}
.wrapper1 {
    border-bottom: 1.5px solid #4361ee;
    box-sizing: border-box;
    height: 22.7px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 6px 8px;
    text-align: center;
}
.frame-parent6 {
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
}
.wrapper2 {
    width: 43px;
    border-bottom: 1.5px solid #4361ee;
    box-sizing: border-box;
    height: 22px;
    overflow: hidden;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 6px 8px;
    text-align: center;
}
.frame-parent5 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 8px;
    font-size: 12px;
    color: #535763;
}
.group-icon1 {
    width: 12.6px;
    position: relative;
    height: 12.6px;
}
.btn-text {
    position: relative;
    letter-spacing: 0.2px;
    line-height: 12.66px;
    font-weight: 500;
}
.boton-prinicipal {
    box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.25), 0px 4px 16px rgba(114, 9, 183, 0.1) inset;
    border-radius: 21.29px;
    background-color: #b5179e;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 6px 8px;
    gap: 6px;
    text-align: center;
    font-size: 11px;
    color: #fff;
    font-family: Rubik;
    cursor: pointer;
}
.btn-text1 {
    position: relative;
    letter-spacing: 0.12px;
    line-height: 13.24px;
    font-weight: 500;
}
.buttonbtnprimary-colorbtn-r {
    border-radius: 22.27px;
    background-color: #f72585;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 8.4px 14.6px;
}
.buttonbtnprimary-colorbtn-r-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    text-align: center;
    font-size: 12.55px;
    color: #fff;
}
.productos {
    width: 100%;
    position: relative;
    border-radius: 20.92px;
    background-color: #fff;
    border: 1.5px solid #4361ee;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 25.1px 24px;
    gap: 25.1px;
    text-align: left;
    font-size: 16px;
    color: #3f37c9;
    font-family: Roboto;
}
.productos-otro {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 25.1px;
    text-align: left;
    font-size: 16px;
    font-family: Roboto;
}
</style>
